import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ImageUpload from "src/Components/GlobalComponents/ImageUplaod";
import PrimaryBtn from "src/Components/GlobalComponents/primaryBtn";
import httpRequest from "src/helpers/httpRequest";
import { IHomePageInterface, ITagsItems } from "src/types/GlobalInterfaces";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { canWrite } from "src/helpers/helperFunctions";
import SelectDropdown from "src/Components/GlobalComponents/SelectDropdown";
import { IPaginated } from "src/types/paginated";
import CustomWebsiteDropdown from "src/Components/GlobalComponents/Widget/CustomWebsiteDropdown";

interface MainBannerType {
  key: string;
  file: File | null;
  tag: string;
  imagePath?: string;
}

interface ICategoryResponse {
  documents: ITagsItems[];
  paginated: IPaginated;
}

const MainBanner: React.FC<{
  allBanner: any[];
  setData: React.Dispatch<React.SetStateAction<IHomePageInterface | null>>;
}> = ({ allBanner, setData }) => {
  const { userDetails } = useSelector((store: RootState) => store.appReducer);
  const hasWriteAccess = canWrite(userDetails, "platformManagement", false);
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [mainBanner, setMainBanner] = useState<MainBannerType[]>([
    { key: "bannerOne", imagePath: "", tag: "", file: null },
    { key: "bannerTwo", imagePath: "", tag: "", file: null },
    { key: "bannerThree", imagePath: "", tag: "", file: null },
    { key: "bannerFour", imagePath: "", tag: "", file: null },
    { key: "bannerFive", imagePath: "", tag: "", file: null },
    { key: "bannerSix", imagePath: "", tag: "", file: null },
    { key: "bannerSeven", imagePath: "", tag: "", file: null },
    { key: "bannerEight", imagePath: "", tag: "", file: null },
    { key: "bannerNine", imagePath: "", tag: "", file: null },
  ]);
  const [tagsLoader, setTagsLoader] = useState<boolean>(false);
  const [tags, setTags] = useState<ITagsItems[]>([]);

  const getAllTags = async () => {
    setTagsLoader(true);
    // let pth = activeTab === 1 ? "/tags/promotional/all" : "/tags/product/all";
    const { res, err } = await httpRequest<ICategoryResponse>({
      path: `/tags/promotional/all`,
    });
    if (res) {
      setTags(res?.documents);
    } else {
      toast(err, { type: "error" });
    }
    setTagsLoader(false);
  };

  useEffect(() => {
    getAllTags();
  }, []);

  useEffect(() => {
    if (allBanner) {
      allBanner.forEach((tm) => {
        setMainBanner((prev) => {
          const bnInd = prev.findIndex((v) => v.key === tm.key);
          if (bnInd !== -1) {
            prev[bnInd] = {
              ...prev[bnInd],
              file: tm.image || null,
              tag: tm.promotionalTag,
            };
          }
          return prev;
        });
      });
    }
  }, [allBanner]);

  const handleSubmit = async () => {
    if (!hasWriteAccess) {
      return;
    }

    if (!mainBanner) {
      toast("Main banner in mandatory.", { type: "error" });
      return;
    }
    const formData = new FormData();
    // Validation Images and Tags
    let allBanner = mainBanner.filter((tm) => tm.file);
    if (allBanner.length !== 9) {
      toast("Please upload all banner images.", { type: "error" });
      return;
    }
    let allTags = mainBanner.filter((tm) => tm.tag);
    if (allTags.length !== 9) {
      toast("Please select all tags.", { type: "error" });
      return;
    }

    mainBanner.forEach((tm) => {
      if (tm.file && tm.file instanceof File) {
        formData.append(`${tm.key}Image`, tm.file || "");
      }
      if (tm.tag) {
        formData.append(`${tm.key}[promotionalTagId]`, tm.tag);
      }
    });
    setIsLoader(true);
    const { res, err } = await httpRequest<{ mainBanner: string }>({
      method: "put",
      path: "/website-manage/section-one",
      params: formData,
      header: { "Content-Type": "multipart/form-data" },
    });
    if (res) {
      toast("Banner Image Updated", { type: "success" });
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  const handleImageChange = (image: File | null, ind: number) => {
    setMainBanner((prev) => {
      const newBanner = [...prev];
      newBanner[ind] = {
        ...newBanner[ind],
        file: image,
      };
      return newBanner;
    });
  };

  const CheckDuplicates = (tm: ITagsItems, index: number) => {
    let allData = mainBanner.filter((t, i) => i !== index);
    return allData.some((t) => t.tag === tm._id);
  };

  return (
    <div className="section__1">
      <h1 className="font-Poppins-SemiBold font-size-25px mb-2 theme-color-green">
        Section 01
      </h1>
      <div className="products-tabs-content">
        <div>
          <h3 className="font-size-18px text-[#2F2F31] mb-3 font-Poppins-Regular">
            Main Banner
          </h3>
          <div className="w-full grid grid-cols-3 gap-8 gap-x-10">
            {mainBanner.map((tm, ind) => {
              return (
                <div className="w-full">
                  <ImageUpload
                    newUi={true}
                    image={tm?.file || tm?.imagePath}
                    onImageChange={(file) => handleImageChange(file, ind)}
                    extraClasses={"w-full min-h-[280px] aspect-square"}
                    labelId={`main-banner-${ind + 1}`}
                    disabled={!hasWriteAccess}
                  />
                  <CustomWebsiteDropdown
                    loading={tagsLoader}
                    options={tags.map((tm, index) => ({
                      label: tm.name,
                      value: tm._id,
                      disabled: CheckDuplicates(tm, ind),
                    }))}
                    data={
                      mainBanner[ind]?.tag
                        ? [
                            {
                              label:
                                tags.find(
                                  (tm) => tm._id === mainBanner[ind]?.tag
                                )?.name || "",
                              value: mainBanner[ind]?.tag,
                            },
                          ]
                        : []
                    }
                    setData={(val) => {
                      console.log("Selected Tag", val);
                      setMainBanner((prev) => {
                        const newBanner = [...prev];
                        newBanner[ind] = {
                          ...newBanner[ind],
                          tag: val[0]?.value || "",
                        };
                        return newBanner;
                      });
                    }}
                    placeholder="Select Tag"
                    dropdownMainId={`main-banner-${ind + 1}`}
                    disabled={!hasWriteAccess}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="flex mt-2 justify-end">
        <PrimaryBtn
          disabled={typeof mainBanner === "object" ? false : true}
          loader={isLoader}
          ButtonText="Save"
          btnExtraStyle={{
            backgroundColor: "#00443f",
            borderRadius: "1.5rem",
          }}
          onPress={handleSubmit}
          btnExtralClasses={`${!hasWriteAccess ? "cursor-not-allowed" : ""}`}
          id="main-banner-save"
        />
      </div>
    </div>
  );
};

export default MainBanner;
